import React from "react";
export default function Loading() {
  return (
    <div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
